export const decorateEntityIds = <T extends { id: number }>(indexes: number[], collection: T[]): T[] => {
  if (!indexes) {
    return []
  }

  return collection.filter((object) => indexes.includes(object.id))
}
